import { render, staticRenderFns } from "./PublicGroups.vue?vue&type=template&id=494d9b1f&scoped=true&"
import script from "./PublicGroups.vue?vue&type=script&lang=js&"
export * from "./PublicGroups.vue?vue&type=script&lang=js&"
import style0 from "./PublicGroups.vue?vue&type=style&index=0&id=494d9b1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d9b1f",
  null
  
)

export default component.exports